import { fromEventPattern, Observable } from 'rxjs';
import { createMutationObserver } from './dom/browsingContext';

export function fromMutationObserver(
  target: Node,
  options?: MutationObserverInit,
): Observable<Parameters<MutationCallback>> {
  return fromEventPattern(
    handler => {
      const observer = createMutationObserver(target, handler);
      observer.observe(target, options);
      return observer;
    },
    (_handler, mutationObserver: MutationObserver) => {
      mutationObserver.disconnect();
    },
  );
}
